import React from 'react'
import { Snackbar, Toast } from '@chilecompra/react-kit'
import { onSetCloseToastSuccess } from './UserNotificationToast.actions'
import { useDispatch, useSelector } from 'react-redux'

/**
 * The Notification toast container
 */
const UserNotificationToastContainer = () => {
  const dispatch = useDispatch()
  const { open, message, handleClose, severity } = useSelector(state => state.userNotification)

  const handleCloseSnackbar = (_, reason) => {
    if (reason === 'clickaway') {
      return
    }
    dispatch(onSetCloseToastSuccess())
    if (typeof handleClose === 'function') {
      try {
        handleClose()
      } catch (error) {}
    }
  }
  return (
    <Snackbar open={open} onClose={handleCloseSnackbar}>
      <Toast severity={severity}>{message}</Toast>
    </Snackbar>
  )
}

export default UserNotificationToastContainer
